import React from 'react';
import PropTypes from 'prop-types';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import ListItemIcon from '@mui/material/ListItemIcon';
import MenuItem from '@mui/material/MenuItem';
import CircularProgress from '@mui/material/CircularProgress';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import EditIcon from '@mui/icons-material/Edit';
import PushPinIcon from '@mui/icons-material/PushPin';
import Star from '@mui/icons-material/Star';
import StarBorder from '@mui/icons-material/StarBorder';
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';
import DeleteIcon from '@mui/icons-material/Delete';
import {
  primary,
  danger,
} from '../../../utils/brandColors';

export class HistoryActionsMenuComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      element: null,
    };
  }

  handleOpen = (e) => {
    this.setState({
      open: true,
      element: e.currentTarget,
    });
  }

  handleClose = () => {
    this.setState({
      open: false,
      element: null,
    });
  }

  handleActionClick = (action) => {
    action();
    this.handleClose();
  }

  render() {
    const {
      isLoading,
      isActiveHorseNote,
      isHighlight,
      onEdit,
      onPin,
      onHighlight,
      onUnHighlight,
      onUnpin,
      onDelete,
    } = this.props;
    return (
      <div>
        {
          isLoading
            ? <CircularProgress size={30} />
            : (
              <IconButton
                edge="end"
                onClick={this.handleOpen}
                id="menu-btn"
                aria-owns={this.state.open
                  ? 'menu-appbar'
                  : null}
                aria-haspopup="true"
              >
                <MoreVertIcon />
              </IconButton>
            )
        }
        <Menu
          id="menu-appbar"
          anchorEl={this.state.element}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
          anchorPosition={{
            top: 0,
            left: 0,
          }}
          open={this.state.open}
          onClose={this.handleClose}
        >
          {
            onEdit
            && (
              <MenuItem onClick={() => this.handleActionClick(onEdit)}>
                <ListItemIcon>
                  <EditIcon sx={{ color: primary[500] }} />
                </ListItemIcon>
                Edit
              </MenuItem>
            )
          }
          {
            (onPin && !isActiveHorseNote)
            && (
              <MenuItem onClick={() => this.handleActionClick(onPin)}>
                <ListItemIcon>
                  <PushPinIcon sx={{ color: primary[500] }} />
                </ListItemIcon>
                Pin
              </MenuItem>
            )
          }
          {
            (onUnpin && isActiveHorseNote)
            && (
              <MenuItem onClick={() => this.handleActionClick(onUnpin)}>
                <ListItemIcon>
                  <RemoveCircleOutlineIcon sx={{ color: primary[500] }} />
                </ListItemIcon>
                Unpin
              </MenuItem>
            )
          }
          {
            (onUnHighlight && isHighlight) && (
              <MenuItem onClick={() => this.handleActionClick(onUnHighlight)}>
                <ListItemIcon>
                  <StarBorder sx={{ color: primary[500] }} />
                </ListItemIcon>
                Remove as Profile Highlight
              </MenuItem>
            )
          }
          {
            (onHighlight && !isHighlight) && (
              <MenuItem onClick={() => this.handleActionClick(onHighlight)}>
                <ListItemIcon>
                  <Star sx={{ color: primary[500] }} />
                </ListItemIcon>
                Add as Profile Highlight
              </MenuItem>
            )
          }
          {
            onDelete
            && (
              <MenuItem onClick={() => this.handleActionClick(onDelete)}>
                <ListItemIcon>
                  <DeleteIcon sx={{ color: danger[500] }} />
                </ListItemIcon>
                Delete
              </MenuItem>
            )
          }
        </Menu>
      </div>
    );
  }
}

HistoryActionsMenuComponent.propTypes = {
  isLoading: PropTypes.bool,
  isActiveHorseNote: PropTypes.bool,
  isHighlight: PropTypes.bool,
  onEdit: PropTypes.func,
  onPin: PropTypes.func,
  onHighlight: PropTypes.func,
  onUnHighlight: PropTypes.func,
  onUnpin: PropTypes.func,
  onDelete: PropTypes.func,
};

HistoryActionsMenuComponent.defaultProps = {
  isLoading: false,
  isActiveHorseNote: false,
  isHighlight: false,
  onEdit: undefined,
  onPin: undefined,
  onHighlight: undefined,
  onUnHighlight: undefined,
  onUnpin: undefined,
  onDelete: undefined,
};

export default HistoryActionsMenuComponent;
